/**
 * アプリケーション定数
 */

import { environment } from '../../../environments/environment';

/** API関連定数 */
export const API_CONSTANTS = {
  /** デフォルトBase URL */
  DEFAULT_BASE_URL: environment.api.baseUrl,
} as const;

/** localStorage キー */
export const STORAGE_KEYS = {
  /** 列設定 */
  COLUMN_SETTINGS: 'prosche_column_settings',

  /** フィルター設定 */
  FILTER_SETTINGS: 'prosche_filter_settings',

  /** 現在タブ */
  CURRENT_TAB: 'prosche_current_tab',

  /** reporterId */
  REPORTER_ID: 'prosche_reporter_id',

  /** セッションコンテキスト */
  SESSION_CONTEXT: 'prosche_session_context',

  /** inspection 共有 URL コンテキスト */
  INSPECTION_ACCESS_CONTEXT: 'prosche_inspection_access_context',

  /** 端末に保持するページモードロック */
  ROUTE_MODE_LOCK: 'prosche_route_mode_lock',

  /** トークン使用有無 */
  TOKEN_ENABLED: 'prosche_token_enabled',

  /** トークン値 */
  TOKEN_VALUE: 'prosche_token_value',

  /** コピー時ヘッダー含有設定 */
  COPY_SELECTION_WITH_HEADERS: 'prosche_copy_selection_with_headers',

  /** グループ状態 */
  GROUP_STATE: 'prosche_group_state',
} as const;

/** フィールド名マッピング（命名揺れ吸収） */
export const FIELD_NAME_MAPPING: Record<string, string> = {
  shipPlannedDate: 'shipPlanningDate',
  // TODO: 追加の命名揺れがあればここに追記
} as const;

/** データ型ごとのデフォルト演算子 */
export const DEFAULT_OPERATORS_BY_TYPE = {
  string: ['in', 'notIn', 'contains', 'notContains', 'equals', 'notEquals', 'startsWith', 'endsWith', 'isEmpty', 'isNotEmpty'],
  number: ['equals', 'notEquals', 'greaterThan', 'lessThan', 'greaterThanOrEqual', 'lessThanOrEqual', 'isEmpty', 'isNotEmpty'],
  date: ['equals', 'notEquals', 'greaterThan', 'lessThan', 'greaterThanOrEqual', 'lessThanOrEqual', 'isEmpty', 'isNotEmpty'],
  boolean: ['equals', 'notEquals'],
} as const;

/** 演算子の日本語ラベル */
export const OPERATOR_LABELS: Record<string, string> = {
  equals: '等しい',
  notEquals: '等しくない',
  contains: '含む',
  notContains: '含まない',
  startsWith: 'で始まる',
  endsWith: 'で終わる',
  greaterThan: 'より大きい',
  lessThan: 'より小さい',
  greaterThanOrEqual: '以上',
  lessThanOrEqual: '以下',
  in: '次のいずれか',
  notIn: '次のいずれでもない',
  isEmpty: '空である',
  isNotEmpty: '空でない',
} as const;
